import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FitnessPage = lazy(() => import('../pages/fitness/page'));
const RecipesPage = lazy(() => import('../pages/recipes/page'));
const CoworkPage = lazy(() => import('../pages/cowork/page'));
const LearnPage = lazy(() => import('../pages/learn/page'));
const TravelPage = lazy(() => import('../pages/travel/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const MarketplacePage = lazy(() => import('../pages/marketplace/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/fitness',
    element: <FitnessPage />,
  },
  {
    path: '/recipes',
    element: <RecipesPage />,
  },
  {
    path: '/cowork',
    element: <CoworkPage />,
  },
  {
    path: '/learn',
    element: <LearnPage />,
  },
  {
    path: '/travel',
    element: <TravelPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
